import axios from 'axios';
import config from '../../config'

let IntegrationApi = {
  getSubscriptions() {
    return axios.get(config.apiUrl + 'integration/subscriptions/')
  },
  disconnectIntegration(key) {
    return axios.delete(config.apiUrl + 'integration/' + key)
  },


  available: {
    activity() {
      return axios.get(config.apiUrl + 'integration/available/activity')
    },
    /**
     * Return list of integrations available to the user for the sleep view
     * @returns {AxiosPromise}
     */
    sleep() {
      return axios.get(config.apiUrl + 'integration/available/sleep')
    }
  },
  FITBIT: {
    getActivityLog(date) {
      return axios.get(config.apiUrl + 'integration/fitbit/activities/log/' + date);
    },
    getNext(link) {
      return axios.post(config.apiUrl + 'integration/fitbit/next/', {
        link: link
      })
    },
    getHeartRate() {
      return axios.get(config.apiUrl + 'integration/fitbit/heart/')
    },
    getDevices() {
      return axios.get(config.apiUrl + 'integration/fitbit/devices/')
    },
    generateHandshake() {
      return axios.get(config.apiUrl + 'integration/fitbit/handshake')
    }
  }
};

export default IntegrationApi;



// WEBPACK FOOTER //
// ./src/api/Integrations/index.js